var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('info-screen',{attrs:{"title":_vm.$ml.get('errorPageTitle'),"text":_vm.text,"action":_vm.nextScreen,"button-text":_vm.$ml.get('errorPageButtonStartAgain'),"headerImg":3,"titleH1":true,"hideButton":this.callbackUrl.length === 0}})}
var staticRenderFns = []

export { render, staticRenderFns }